import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import Editor from 'vue-editor-js'

Vue.config.productionTip = false
Vue.prototype.$http = axios;
//Vue.prototype.$serverApiLink = 'https://3363-109-106-141-44.ngrok-free.app/v1/';
Vue.prototype.$serverApiLink = 'http://serviceland.impeltech.ru/v1/';
Vue.prototype.$crmApiLink = 'http://apicrm.impeltech.ru/';

function getAccessToken() {
  return `Bearer ${store.state.authTokens.access}`
}

function logout() {
  store.dispatch('logout').then(r => window.console.log('logout dispatch from Main. ' +r ));
  router.push({name: 'login'}).then(r => window.console.log('logout access error from Main. ' +r));
}

function badRefreshToken(error) {
  window.console.log('Bad refresh JWT tokens' + error);
  logout()
}

// Function that will be called to refresh authorization
const refreshAuthLogic = failedRequest =>
    axios.post(Vue.prototype.$serverApiLink+'auth/refresh', {}, {headers: {Refresh: `Bearer ${store.state.authTokens.refresh}`, 'Content-Type': 'application/json'}}).then(tokenRefreshResponse => {
        window.console.log(store.state.authTokens.refresh)
      store.commit('setAuthTokens', tokenRefreshResponse.data.data.auth);
      failedRequest.response.config.headers['Authorization'] = tokenRefreshResponse.data.data.auth.access;
      return Promise.resolve();
    }).catch(error => {
        window.console.log(store.state.authTokens.refresh)
      badRefreshToken(error);
      return Promise.reject('BAD REFRESH AUTH TOKEN');
    });

// Instantiate the interceptor (you can chain it as it returns the axios instance)
createAuthRefreshInterceptor(axios, refreshAuthLogic);
axios.interceptors.request.use(request => {
    request.headers['Authorization'] = getAccessToken();
    request.headers['Content-Type'] = "application/json";
    return request;
});

Vue.use(Editor);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
